import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useAddPastPaper = () => {
  return useMutation((newTest) => {
    return axiosPost("/api/cw/createPastPaper", newTest);
  });
};

export default useAddPastPaper;
